import { CircularButton } from '@ui/kit';
import { useIArkNavigation } from './hook.navigation.js';
import { jsx } from 'react/jsx-runtime';

function NavigationButton(props) {
  const {
    canGoBackwards,
    canGoForwards,
    handleGoBackwards,
    handleGoForwards
  } = useIArkNavigation();
  const canNavigate = props.direction === "backwards" ? canGoBackwards : canGoForwards;
  const handleNavigation = () => {
    if (props.direction === "backwards") {
      handleGoBackwards();
    } else {
      handleGoForwards();
    }
    props.onClick?.();
  };
  if (props.component.data.pages.length === 1) {
    return null;
  }
  return /*#__PURE__*/jsx(CircularButton, {
    onClick: handleNavigation,
    inversed: props.direction === "backwards",
    size: "large",
    disabled: !canNavigate
  });
}

export { NavigationButton };
//# sourceMappingURL=atom.navigation-button.js.map
